import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import IriDisplay from '../../vocabulary/taxonomies/IriDisplay';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class TaskResourceDisplay extends React.Component {

  render() {

    const { data, classes, defaultLang, graph, components, viewLang, project } = this.props;
    const { inScheme, id } = data;

    const schemes = inScheme ?
      Array.isArray(inScheme) ? inScheme : [inScheme]
      :
      null;

    return (
      <React.Fragment>
        <TableCell data-test="resource" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 2 }}>
            <IriDisplay
              id={id}
              compact={true}
              components={components}
              projectIRI={project}
              useIfWorkflow={true}
              handleNotAvailable={true}
              graph={graph}
              viewLang={defaultLang}
              defaultLang={defaultLang} />
          </div>
        </TableCell>
        <TableCell data-test="component" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 2 }}>
            {schemes && schemes.map(scheme =>
              <IriDisplay
                key={scheme}
                id={scheme}
                compact={true}
                useIfWorkflow={true}
                components={components}
                projectIRI={project}
                handleNotAvailable={true}
                graph={graph}
                viewLang={viewLang}
                defaultLang={defaultLang} />
            )}
          </div>
        </TableCell>
      </React.Fragment>
    );
  }
}

TaskResourceDisplay.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired,
  components: PropTypes.array.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(TaskResourceDisplay, ["ALL"], null, {}, true));